import { Badge, ButtonGroup, ButtonIcon, ButtonText, Col, Form, FormControl, Grid, Icon, Input, InputOption, Row, Td, Tr, Typography } from "@visa/vds";
import MCSPagedTable from "components/MCSPagedTable";
import MultipleFilterSection from "pages/ApprovedProducts/Components/MultipleFilterSection";
import React, { useEffect, useState } from "react";
import { DateHelper } from "_helpers/DateHelper";
import MCSOverlayLoading from "components/MCSOverlayLoading";
import { trackPromise } from "react-promise-tracker";
import { approvedProductsService } from "services/approvedProducts.service";
import { createFilterFromTags, createTags } from "../helper";
import ApprovedProductsAllDialog from "./ApprovedProductsAllDialog";
import { FileHelper } from "_helpers/FileHelper";
import { GlobalAlertContext } from "../../../context/GlobalAlertContext";
import "../ApprovedProducts.css";

const DEFAULT_SORTBY = "VendorName"
const PAGE_SIZE = 10;
const PUBLIC_INDICATOR_Y = "Y"
const ROW_FORMAT_DATE = "yyyy-MM-dd"
const UPLOAD_DATE_FORMAT_DATE = "dd MMM yyyy"


const ApprovedProducts = (props) => {

    const [desc, setDesc] = useState(false);
    const [error, setError] = useState(null);
    const [filter, setFilter] = useState(approvedProductsService.prepareFilter());
    const [lastUploadDate, setLastUploadDate] = useState(null);
    const [loading, setLoading] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [page, setPage] = useState(1);
    const [searchValue, setSearchValue] = useState("");
    const [sortBy, setSortBy] = useState(DEFAULT_SORTBY);
    const [tags, setTags] = useState(createTags([], props.isAdmin))
    const [tableData, setTableData] = useState(null);
    const [totalCount, setTotalCount] = useState(0);
    const [totalPage, setTotalPage] = useState(0);
    const [typingTimeOut, setTypingTimeout] = useState({ name: "", timeout: 0 });


    const handleClickExport = async (alertObj) => {
        setLoading(true)
        if (tableData && tableData.length > 0) {
            let skipCount = (page - 1) * PAGE_SIZE;
            trackPromise(
                props.apiExport(skipCount, sortBy, desc, filter, searchValue))
                .then((response) => {
                    FileHelper.DownloadFile(response);
                }).finally(
                    () => setLoading(false)
                )
        } else {
            alertObj.setErrorMessage("No result can be exported.");
            setLoading(false)
        }
    };

    const handleSearchChange = async (newSearchValue) => {
        setPage(1)
        await fetchData(1, sortBy, desc, filter, newSearchValue)
    }

    const handlePageChange = async (newPage) => {
        setPage(newPage)
        await fetchData(newPage, sortBy, desc, filter, searchValue)
    };

    const handleManualSearch = (event) => {
        setSearchValue(event.target.value);
        if (event.key === "Enter") {
            event.preventDefault();
            handleSearchChange(event.target.value);
            clearTimeout(typingTimeOut.timeout);
        }
    };

    const handleFilter = async (value, idx) => {
        let newTags = { ...tags }
        let tag = newTags[value]
        tag.items[idx].checked = !tag.items[idx].checked
        newTags[value] = tag

        const newFilter = createFilterFromTags(newTags, props.isAdmin)
        setTags(newTags)
        setFilter(newFilter)
        setPage(1)
        await fetchData(1, sortBy, desc, newFilter, searchValue)
    }

    const handleAutoSearch = (searchValue) => {
        setSearchValue(searchValue);
        if (typingTimeOut.timeout) {
            clearTimeout(typingTimeOut.timeout);
        }
        setTypingTimeout({
            name: searchValue,
            timeout: window.setTimeout(() => handleSearchChange(searchValue), 1500),
        });
    };

    const handleSortChange = async (sortBy = null, desc = false) => {
        setSortBy(sortBy)
        setDesc(desc)
        setPage(1)
        await fetchData(1, sortBy, desc, filter, searchValue)
    }

    const fetchData = async (page, sortBy, desc, filter, searchValue) => {
        let skipCount = (page - 1) * PAGE_SIZE;
        setLoading(true)
        trackPromise(
            props.api(skipCount, sortBy, desc, filter, searchValue)
                .then((response) => {
                    let dto = response.data
                    setTableData(dto.items);
                    setTotalCount(dto.totalCount);
                    setTotalPage(Math.ceil(dto.totalCount / PAGE_SIZE));
                })
                .catch((error) => setError(error))
        ).finally(
            () => setLoading(false)
        );
    };

    const fetchProtocolVersionsAndLastUploadDate = async () => {
        console.log(props.IS_ADMIN)
        trackPromise(approvedProductsService
            .GetProtocolVersionsAndLastUploadDate(props.isAdmin)
            .then(response => {
                let dto = response.data
                setTags(createTags(dto.protocolVersions, props.isAdmin));
                setLastUploadDate(dto.lastUploadDate)
            }))
            .catch((error) => {
                setTags(createTags([], props.isAdmin));
            })
    }

    useEffect(() => {
        fetchProtocolVersionsAndLastUploadDate()
        fetchData(page, sortBy, desc, filter, searchValue);
    }, []);

    if (error) {
        return <div>Error: {props.error.message}</div>;
    } else {
        return (
            <GlobalAlertContext.Consumer>
                {(alertObj) => (
                    <>
                        <ApprovedProductsAllDialog
                            openDialog={openDialog}
                            setOpenDialog={setOpenDialog}
                            handleClickExport={() => handleClickExport(alertObj)}
                        />
                        {loading && <MCSOverlayLoading />}
                        <Grid>
                            <Row>
                                <Col className="vss-header">
                                    <Typography tag="h1" variant="headline" className="margin-block-end-0px">
                                        {props.titlePage}
                                    </Typography>
                                </Col>
                            </Row>
                            <Row>
                                <Col className="padding-top-0px padding-bottom-0px">
                                    <Typography tag="h2" className="filter-by-text subtitle-text" style={{ paddingLeft: "12px" }}>Browse EMV 3DS solution providers already certified by Visa</Typography>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={4} sm={8} md={2} lg={2} xl={2} className="filter-col">
                                    <MultipleFilterSection
                                        tags={tags}
                                        handleChange={handleFilter}
                                        isAdmin={props.isAdmin}
                                    />
                                </Col>
                                <Col xs={4} sm={8} md={6} lg={10} xl={10}>
                                    <div className="approved-products-table">
                                        <MCSPagedTable
                                            size={"compact"}
                                            colHeaders={props.colHeaders}
                                            useExport={true}
                                            handleExport={props.isAdmin ? () => setOpenDialog(true) : handleClickExport}
                                            useSearchBar={true}
                                            searchHelpText={props.helpText}
                                            searchVal={searchValue}
                                            setSearchVal={setSearchValue}
                                            handleSearchChange={handleSearchChange}
                                            usePagination={true}
                                            selectedPage={page}
                                            setSelectedPage={handlePageChange}
                                            totalPages={totalPage}
                                            ordered={sortBy}
                                            setOrdered={setSortBy}
                                            sortData={handleSortChange}
                                            isDsc={desc}
                                            setDsc={setDesc}
                                            PAGE_SIZE={PAGE_SIZE}
                                            totalCount={totalCount}
                                            tableData={
                                                tableData &&
                                                tableData.map((row, key) => (
                                                    <Tr key={key}>
                                                        <Td name={"vendorName_" + key}>{row.vendorName}</Td>
                                                        {props.isAdmin && <Td>{row.bid}</Td>}
                                                        <Td name={"component_" + key}>{row.component}</Td>
                                                        <Td name={"protocolVersion_" + key}>{row.protocolVersion}</Td>
                                                        <Td name={"productName_" + key}>{row.productName}</Td>
                                                        <Td name={"supportSCA_" + key}>{row.supportSCATestCases}</Td>
                                                        <Td name={"supportDAF_" + key}>{row.supportDAFTestCases}</Td>
                                                        <Td name={"supportBME_" + key}>{row.supportBMETestCases}</Td>
                                                        <Td name={"visaCompId_" + key}>{row.visaCompId}</Td>
                                                        <Td name={"expirationDate_" + key}>{DateHelper.ToFormattedDate(row.expirationDate, ROW_FORMAT_DATE)}</Td>
                                                        {props.isAdmin && <Td>{row.emvCoRefNum}</Td>}
                                                        <Td name={"validity_" + key}>{row.validity}</Td>
                                                        <Td name={"vendorContact_" + key}>{row.vendorContact}</Td>
                                                        {props.isAdmin
                                                            &&
                                                            <Td>
                                                                {row.publicIndicator === PUBLIC_INDICATOR_Y
                                                                    ? row.publicIndicator
                                                                    : <Badge type="critical">N</Badge>}
                                                            </Td>
                                                        }
                                                    </Tr>
                                                ))
                                            }
                                        />
                                    </div>
                                    <Typography tag="h4">Footnotes</Typography>
                                    <div className="font-size-12px">{"\u00B9 Compliance to 2.2 requires support of all active EMV 3DS Protocol Versions. As part of Visa’s EMV 3DS 2.2 testing, the product providers are required to complete 2.1 test cases as well. The EMV 3DS Protocol Version listed is the highest version certified with Visa."}</div>
                                    <div className="font-size-12px">{"\u00B2 Provider’s solution supports SCA Enhanced Functionality test cases which includes Visa Delegated Authentication, Transaction Risk Analysis, Secure Corporate Exemption, and Acquirer Country code."}</div>
                                    <div className="font-size-12px">{"\u00B3 Provider’s solution supports Digital Authentication Framework test cases during certification."}</div>
                                    <div className="font-size-12px">{"\u2074 Provider's solution supports EMV Bridging Message Extension test cases during certification."}</div>
                                    <br/>
                                    <div className="font-size-12px color-visa-blue">Last Updated: {lastUploadDate ? DateHelper.ToFormattedDate(lastUploadDate, UPLOAD_DATE_FORMAT_DATE) : ""} </div>
                                </Col>
                            </Row>
                        </Grid>
                    </>
                )}
            </GlobalAlertContext.Consumer>
        )
    }
};

export default ApprovedProducts;
